/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/api-v2-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { WebAppGetPersonsByIdQueryResponse, WebAppGetPersonsByIdPathParams, WebAppGetPersonsById401, WebAppGetPersonsById403, WebAppGetPersonsById404 } from "../models/WebAppGetPersonsById";

export function getWebAppGetPersonsByIdUrl(personId: WebAppGetPersonsByIdPathParams["personId"]) {
  const res = { method: 'GET', url: `/web-app/v1/persons/${personId}` as const }
  return res
}

/**
 * @description Retrieves a single person by id.
 * @summary Get person by id
 * {@link /web-app/v1/persons/:personId}
 */
export async function webAppGetPersonsById(personId: WebAppGetPersonsByIdPathParams["personId"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<WebAppGetPersonsByIdQueryResponse, ResponseErrorConfig<WebAppGetPersonsById401 | WebAppGetPersonsById403 | WebAppGetPersonsById404>, unknown>({ method : "GET", url : getWebAppGetPersonsByIdUrl(personId).url.toString(), ... requestConfig })
  return res.data
}